export default __webpack_public_path__ + "static/media/arrow.83d0d916.png";